import './myCss.css'
import './dsCSS.css'
import linkedin from './images/LinkedIn.jpg'
import github from './images/github.jpg'
import medium from './images/medium.jpg'


const Social = () => {

    return (
        <>
            <div id='description-2'>Social Links below:</div>
            <div className="icon-links">

                <a href="https://github.com/jeffng5?tab=repositories" target="_blank" rel='noreferrer'><img
                    src={github} className = 'icons' id="icons" alt='github'/></a>
                <a href="https://medium.com/@jeffreyng-82" target="_blank" rel='noreferrer'><img src={medium} id = 'icons' className="icons" alt='medium'/></a>
                <a href="https://www.linkedin.com/in/jeffrey-ng5/" target="_blank" rel='noreferrer'><img className="icons" alt='linkedin' id= 'icons'
                    src={linkedin}/></a>
                <a href='https://github.com/halujeff5?tab=repositories' target="_blank" rel='noreferrer'><img src={github} className='icons' id = 'icons' alt='Main github profile'/><h4 id = 'main-github'>Main Github</h4></a>
            </div>

        </>
    )
}

export default Social
